import { ApplicationUserStatus, IPagingPagingItems } from "../Common/CommonComponent";
import { ApiUtility } from "../Utilities/ApiUtility.axios";
import { Roles } from "./AuthService";

export enum ReleaseUpdateTypes {
    Unknown = 0,
    Enhancement = 1,
    New = 2,
    Fix = 3
}
export interface userDetailsProps {
    practiceId?: number;
    setLoading?: (v: any) => void;
    listParams?: any;
    setListParams?: (v: any) => void;
    pagingItems: IPagingPagingItems;
    setPagingItems: (v: any) => void;
}

export const roleOption = [
    { value: Roles.SuperAdminC, label: "Super Admin" },
    { value: Roles.SubAdminC, label: "Sub Admin" },
];

export const roleTableShow: Record<string, string> = {
    "SUPERADMIN": "Super Admin",
    "SUBADMIN": "Sub Admin"
}
class UserService {
    route = `/Api/User`;

    getUsers = (start: number, length: any, search: string, sortCol: any, sortDir: any, practiceId: number = 0, status: ApplicationUserStatus, roles: "") =>
        ApiUtility.get(`${this.route}`, { start, length, search, sortDir, sortCol, practiceId, status, roles });

    getUserDetails = (id: string) => ApiUtility.get(`${this.route}/${id}`);

    getUserOptions = () => ApiUtility.get(`${this.route}/getUserOptions`);

    updateUserDetails = (id: string, params: any) => ApiUtility.post(`${this.route}/Profile/${id}`, params);

    createNewUser = (params: any) => ApiUtility.post(`${this.route}`, params);

    getUserDetailsforChart = () => ApiUtility.get(`${this.route}/ChartView`);

    postImage = (id?: string, params?: any) => ApiUtility.postForm(`${this.route}/profilepicture${id ? '?id=' + id : ''}`, params);

    toggleUserStatus = (id: string, status: ApplicationUserStatus) => ApiUtility.post(`${this.route}/${id}/ToggleStatus/${status}`, "");
}
export default new UserService();